<template>
  <div class="reportHeader">
    <div class="reportHeader__grid">
      <div>
        <h2>{{ heading }}</h2>
        <p v-if="lastUpdate" class="reportHeader__grid__lastUpdate">
          {{ lastUpdate }}
        </p>
      </div>
      <LandlordProfileSelector :value="selectedProfiles" @input="setSelectedProfiles" />
    </div>
  </div>
</template>

<script>
import LandlordProfileSelector from '@/components/reports/LandlordProfileSelector.vue';
import { mapGetters, mapMutations, mapState } from 'vuex';
import InfoCard from '@modules/husleie-framework/src/components/layout/cards/InfoCard.vue';

export default {
  name: 'ReportHeader',

  components: {
    LandlordProfileSelector,
    'hl-InfoCard': InfoCard,
  },

  props: {
    heading: String,
    infoTextHtml: String,
    lastUpdate: String,
  },

  data() {
    return {
      fromDate: '01.01.2020',
      toDate: '01.01.2020',
    };
  },

  computed: {
    ...mapState('reports', {
      selectedProfiles: state => state.selectedProfiles,
      profileInitiallySelected: state => state.profileInitiallySelected,
    }),
    ...mapGetters(['getLandlordId', 'getWhoAmI', 'getLandlordProfilesMeta']),
  },

  watch: {
    /**
     * Make sure to initially select the landlord profile from URL.
     * If the user has overridden this selection we keep the selection.
     */
    getLandlordProfilesMeta: {
      handler(newValue) {
        if (newValue.length > 0 && !this.profileInitiallySelected) {
          const id = parseInt(
            this.getLandlordId || this.getWhoAmI.preferences.defaultLandlordId || this.getLandlordProfilesMeta[0].id,
            10
          );
          const landlord = newValue.find(x => x.id === id);
          if (landlord) {
            this.setSelectedProfiles([landlord]);
            this.setProfileInitiallySelected(true);
          }
        }
      },
      immediate: true,
    },
  },

  methods: {
    ...mapMutations('reports', ['setSelectedProfiles', 'setProfileInitiallySelected']),
  },
};
</script>

<style lang="scss" scoped>
.reportHeader__grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 1rem 2rem;
}
.reportHeader__grid__lastUpdate {
  font-size: 1rem;
  color: $gray-700;
}
</style>
